import { useFormikContext } from 'formik';
import React from 'react';

import { AutocompleteField } from '@components/FormFields';
import DropdownField from '@components/FormFields/DropdownField';
import { useEntitiesCreate } from '@hooks';
import { autocompleteEntities } from '@utils/backend-api/entities';
import {
  ENTITY_TYPE_JOB_FUNCTION,
  ENTITY_WORD_TYPE_COMMON,
  JOB_FUNCTION_OPTIONS,
  PROFILE_FIELD_OTHER_VALUE,
} from '@utils/backend-api/profileSettings';

import { StepProfileFormProps } from '../StepProfile';

const JobFunctionFields = () => {
  const { values } = useFormikContext<StepProfileFormProps>();
  const { mutateAsync: createEntityAsync } = useEntitiesCreate();

  return (
    <>
      <DropdownField
        name="jobFunction"
        options={JOB_FUNCTION_OPTIONS}
        label="Job Function&#42;"
        placeholder="Select"
        isClearable={false}
      />
      {values.jobFunction.value === PROFILE_FIELD_OTHER_VALUE && (
        <AutocompleteField
          name="customJobFunction"
          fetchMethod={(value) =>
            autocompleteEntities({
              fragment: value,
              entity_type: ENTITY_TYPE_JOB_FUNCTION,
            })
          }
          createMethod={(value) =>
            createEntityAsync({
              name: value,
              entity_type: ENTITY_TYPE_JOB_FUNCTION,
              word_type: ENTITY_WORD_TYPE_COMMON,
            })
          }
        />
      )}
    </>
  );
};

export default JobFunctionFields;
